import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "monitoring" }
const _hoisted_2 = { class: "monitoring__danger" }
const _hoisted_3 = ["onClick", "id"]
const _hoisted_4 = { class: "dialog-alert__header" }
const _hoisted_5 = { class: "dialog-alert__title" }
const _hoisted_6 = { class: "dialog-alert__content" }
const _hoisted_7 = { class: "dialog-alert__section" }
const _hoisted_8 = { class: "dialog-alert__box" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "dialog-alert__problem" }
const _hoisted_11 = { class: "dialog-alert__recomendation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "monitoring__danger",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMenuAlerts && _ctx.openMenuAlerts(...args)))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-nav-information" }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.alertText), 1),
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icon-nav-bullet_down" }, null, -1))
      ]),
      (_ctx.showAlerts)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: "monitoring__alerts-list",
            onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveMenuAlert && _ctx.mouseLeaveMenuAlert(...args)))
          }, [
            _createElementVNode("li", _hoisted_2, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "icon-nav-information" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.alertText), 1),
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "icon-nav-bullet_up" }, null, -1))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: ($event: any) => (_ctx.showDialog(alert)),
                id: alert.cod
              }, [
                _createElementVNode("span", null, _toDisplayString(alert.title), 1),
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "icon-nav-arrow_right" }, null, -1))
              ], 8, _hoisted_3))
            }), 128))
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      class: "dialog-alert",
      visible: _ctx.isVisible,
      draggable: false,
      modal: true,
      closable: true,
      "onUpdate:visible": _ctx.hideDialog
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.alert.title), 1)
        ])
      ]),
      footer: _withCtx(() => _cache[8] || (_cache[8] = [
        _createElementVNode("div", { class: "dialog-alert__footer" }, [
          _createElementVNode("i", { class: "icon-nav-information" }),
          _createElementVNode("p", null, " Siga a recomendação para melhorar a saúde da sua base. Se o problema persistir fale com seu account. ")
        ], -1)
      ])),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "dialog-alert__location" }, "Seção onde ocorre:", -1)),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.props.title), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", {
              class: "dialog-alert__subtitle",
              innerHTML: _ctx.alert.subtitle
            }, null, 8, _hoisted_9),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.alert.cod), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.alert.recommendation), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onUpdate:visible"])
  ], 64))
}